import { Selector, createSelector } from '@ngrx/store';
import * as Actions from '../actions/index';

export interface State {
  loading: boolean;
  payload: any[];
  results: any[];
  error: any[];
  progress?: number;
}

const DEFAULT_STATE: State = {
  loading: false,
  payload: null,
  results: null,
  error: null,
};

export function reducer(state: State = DEFAULT_STATE, action: Actions.CAAction) {
  switch (action.type) {
    case Actions.REQUEST_BULK_RESET:
      return { ...DEFAULT_STATE };
    case Actions.Customers.REQUEST_BULK_ADD_CUSTOMERS:
    case Actions.Members.REQUEST_BULK_IMPORT: {
      return { ...state, payload: action.payload, loading: true, error: null };
    }
    case Actions.Customers.PROGRESS_BULK_ADD_CUSTOMERS:
      return {
        ...state,
        progress: action.payload,
      };

    case Actions.Customers.RESPONSE_FAIL_BULK_ADD_CUSTOMERS:
    case Actions.Members.RESPONSE_FAIL_BULK_IMPORT:
      return { ...state, error: action.payload, loading: false };
    case Actions.Customers.RESPONSE_SUCCESS_BULK_ADD_CUSTOMERS:
    case Actions.Members.RESPONSE_SUCCESS_BULK_IMPORT:
      return { ...state, results: action.payload, loading: false, error: null };
    default:
      return state;
  }
}

export const getLoading = (state: State) => state.loading;
export const getResults = (state: State) => state.results;
export const getError = (state: State) => state.results;
export const getProgress = (state: State) => state.progress;

export const createSelectors = (rootReducer: Selector<any, any>) => ({
  getLoading: createSelector(rootReducer, getLoading),
  getResults: createSelector(rootReducer, getResults),
  getError: createSelector(rootReducer, getError),
  getProgress: createSelector(rootReducer, getProgress),
});
